// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';

/**
 * A section whose backing data no upstream contract serves yet.
 *
 * Deliberately explicit rather than an empty table or a zeroed tile: a reader
 * must be able to tell "nothing is bound" (a compliance finding) from "nobody
 * publishes binding state" (a missing contract). `detail` names which contract
 * is silent, so the gap is legible without opening the PR description.
 */
export default function UnavailablePanel({ title, detail }: { title: string; detail: string }) {
  return (
    <div className="sg-unavailable" role="note">
      <span className="sg-unavailable-title">{title}</span>
      <p className="sg-unavailable-detail">{detail}</p>
    </div>
  );
}
